export default __webpack_public_path__ + "static/media/Cattura5.703d9759.jpg";